<template>

  <div
    class="row"
    :class="{'box-loading': loading}">
    <div class="col-sm-7">
      <ul
        class="list-group"
        v-sortable="{ items: stages_and_actions}">

        <JobFormStages2Item
          v-for="(item, index) in stages_and_actions"
          :key="index"
          @remove="remove(index)"
          v-model="stages_and_actions[index]"
          :fixed="item.stage_id && item.stage_id ? item.stage_id.fixed : false" />

      </ul>
    </div>
    <div class="col-sm-5">
      <ul class="list-group">
        <li
          class="list-group-item"
          v-for="(item, index) in notSelected"
          :key="index">

          <div class="d-flex">
            <div class="w-100">{{ item.name }}</div>
            <div
              v-if="!item.fixed"
              class="ml-2">
              <a
                href="javascript:void(0)"
                @click="addStage(index)">{{ $t('Add') }}</a>
            </div>
          </div>
          
        </li>
      </ul>
    </div>
  </div>

</template>


<script>
// import _ from 'lodash'
import JobFormStages2Item from './JobFormStages2Item'

export default {
  name: 'JobFormStages',
  components: {
    JobFormStages2Item
  },
  props: [
    'initJob',
    'validateErrors'
  ],
  data () {
    return {
      loading: false,
      stages_and_actions: this.$clone(this.initJob.stages_and_actions || []),
      allStages: []
    }
  },
  computed: {
    notSelected () {
      return this.allStages.filter(stage => {
        return !this.stages_and_actions.find(v => v.stage_id._id === stage._id)
      })
    },
    selectedIds () {
      return this.stages_and_actions.map(v => v.stage_id._id)
    }
  },
  watch: {
    stages_and_actions: {
      handler: function (newValue) {
        this.$emit('changed', {
          stages_and_actions: newValue
        })
      },
      deep: true
    }
  },
  created () {
    this.loadStages()
  },
  methods: {
    loadStages () {
      this.loading = true

      this.$store
      .dispatch('getStages', {
        limit: 1000
      })
      .then((result) => {
        this.loading = false
        this.allStages = result.filter(item => {
          return item.active || this.selectedIds.includes(item._id)
        })
      })
    },
    addStage (index) {
      const item = this.notSelected[index]

      const afterIndex = this.stages_and_actions.findIndex(stage => {
        const findStage = this.allStages.find(item => item._id === (stage.stage_id ? stage.stage_id._id : null))
        const findStagePosition = findStage ? findStage.position : 0
        return findStagePosition >= item.position
      })

      const newIndex = afterIndex >= 0 ? afterIndex : this.stages_and_actions.length

      this.stages_and_actions.splice(newIndex, 0, {
        stage_id: item,
        actions: item.actions
      })
    },
    remove (index) {
      this.stages_and_actions.splice(index, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JobForm/JobFormStages2.vue